import logger from '@/lib/logger.js'

class SummaryData {
    constructor(reportData) {
        logger.log('SummaryData::create()', reportData)

        this.forecast = {}
        this.numMonths = 0
        this.items = []

        if (reportData !== undefined)
            this.parseReportData(reportData)            
    }

    parseReportData(reportData) {
        logger.log('SummaryData::parseReportData()', reportData)

        this.forecast = reportData.forecast
        this.numMonths = reportData.numMonths
        this.items = []
        
        for(let i = 0; i < reportData.data.length; i++) {
            let psrc = reportData.data[i]
            let varGroups = psrc.forecastData.map((x) => x.varGroup)
            logger.log('varGroups', varGroups)

            let item = {
                name: psrc.point.name,
                id: psrc.point.id,
                values: []
            }
            
            varGroups.forEach((varGroup) => {
                let forecastData = psrc.forecastData.find((x) => x.varGroup == varGroup)
                let historicalData = psrc.historicalData.find((x) => x.varGroup == varGroup)

                logger.log('data for ' + varGroup, { f: forecastData, h: historicalData })

                let itemValues = {
                    varGroup: varGroup,
                    varid: forecastData.varid,
                    name: forecastData.name,
                    forecastUnits: forecastData.units,
                    forecast: forecastData.values,
                    historicalUnits: historicalData.units,
                    historical: historicalData.values
                }

                item.values.push(itemValues)
            })

            this.items.push(item)
        }        

        logger.log('SummaryData::parseReportData() complete', this)
    }
}

export default SummaryData